module.exports = __webpack_public_path__ + "static/img/a3.26f339c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/certificate/attestation/a3.png
// module id = EdHe
// module chunks = 0